<div class="main-container-login">
  <div class="light-side-logo">
    <img src="{{logoSideSistema}}" alt="homepage">
  </div>
  <div class="login-info">
    <div class="content">
      <div class="header-login" >
        <div class="logo-junji"></div>
        <img *ngIf="logoSistemaTexto == ''" src="{{logoSistema}}" height="70px" class="light-logo" alt="homepage" style="flex: 0;">
      </div>
      <div class="container-access">
        <div>
        <p class="title-login">{{nSistema}}</p>
      </div><br><br>
        <div *ngIf="showLogins">
          <mat-form-field style="background-color: white;" appearance="outline">
            <mat-label>INICIAR SESIÓN CON...</mat-label>
            <mat-select [(value)]="selectedOption">
              <mat-select-trigger>
                <div class="option-content">
                  <img src="{{selectedOption?.imagen}}" alt="{{selectedOption?.texto}}" class="option-img">
                  <span class="option-text">{{ selectedOption?.texto }}</span>
                </div>
              </mat-select-trigger>
              <mat-option *ngFor="let login of logins" [value]="login">
                <div class="option-content">
                  <img src="{{login.imagen}}" alt="{{login.texto}}" class="option-img">
                  <span class="option-text"><h3>{{login.texto}}</h3></span>
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="container-inputs-login">         
          <app-primary-button (click)="signIn()" buttonText="Acceder" buttonClass="btn btn-primary" class="save-btn"/>
        </div><br><br>
        <div class="container-message-error">        
          <div *ngIf="mensajeSistema != ''" [ngClass]="{'message-sign-in-warn icon-warn': this.estadoSistema == 'ACTIVO', 'message-sign-in-block icon-block' : this.estadoSistema == 'INACTIVO'}">
            <p class="message"> {{ mensajeSistema }}</p>
          </div>
        </div>
        <div class="help-user" *ngIf="contactInfo.email != '' || contactInfo.phone != ''">
          <p class="title">¿Necesitas ayuda?</p>
          <p class="icon-mail contact" *ngIf="contactInfo.email != ''">Escríbenos al e-mail: <a
              href="mailto: {{contactInfo.email}}">{{contactInfo.email}}</a></p>
          <p *ngIf="contactInfo.phone != ''" class="icon-phone contact">Llámanos al: <span>{{contactInfo.phone}}</span></p><p *ngIf="contactInfo.extension != ''"> o al anexo
            <span>{{contactInfo.extension}}</span></p>
        </div>
      </div>
    </div>
  </div>
</div>